module.exports = __webpack_public_path__ + "img/bg2.4274e395.png";